import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';


@Injectable()
export class TimeZoneService {

    private resourceUrl = 'api/timezones';

    constructor(private http: HttpClient) { }

    query(): Observable<any> {
        return this.http.get<HttpResponse<any>>(this.resourceUrl);
    }

    server(): Observable<any> {
        return this.http.get<HttpResponse<any>>(this.resourceUrl + '/current');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/timezone/timezone.service.ts